module.exports = __webpack_public_path__ + "static/media/background-sobre.3291333b.jpg";